import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useState } from 'react';

interface AppStoreInterface {
    logo: string | null;
    banner: string | null;
    scriptContent: string | null;
    regulation: string | null;
}

interface AppContextInterface {
    setAppStore: Dispatch<SetStateAction<AppStoreInterface>>;
    appStore: AppStoreInterface;
}

const INITIAL_STATE: AppStoreInterface = {
    logo: null,
    banner: null,
    scriptContent: null,
    regulation: null
};

export const AppContext = createContext<AppContextInterface>({} as AppContextInterface);

export const AppProvider = ({children}: { children: ReactNode}) => {
    const [appStore, setAppStore] = useState<AppStoreInterface>(INITIAL_STATE);

    return (
        <AppContext.Provider value={{ appStore, setAppStore }}>
            {children}
        </AppContext.Provider>
    );
};

export function useAppStore() {
    return useContext(AppContext);
}